import { supabase } from "../supabase-client";
import { BadgeType } from "@/app/@types";

export const getUserBadges = async (userId: string): Promise<BadgeType[]> => {
  try {

    if (!userId) {
      throw new Error('User ID is required');
    }

    const { data, error } = await supabase
      .from("badges")
      .select("*")
      .eq("user_id", userId)
      .order("earned_at", { ascending: false });

    if (error) {
      console.error("Error fetching badges:", error);
      throw new Error(`Database error: ${error.message}`);
    }

    return data || [];
    
  } catch (error) {
    console.error('Failed to get user badges:', error);
    
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error('Unexpected error occurred while fetching user badges');
    }
  }
};